import styled from 'styled-components';

export const PageTitleBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const PageTitleRowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PageTitleBackBtnWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

export const PageTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const PageTitleButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;
